import React from "react";

export default function Row({label, children}) {
  return <tr>
    <td className="label">{label}</td>
    <td>
      {children}
    </td>
  </tr>
}